<template>
  <div>
    <h3 class="delete-account__header">Delete Account</h3>
    <p>
      Your account and your data will be permanently deleted. You can downgrade
      to a free plan instead to keep it.
    </p>
    <button class="delete-account__btn btns btns--red" @click="showPopup">
      Delete your account
    </button>
    <DeleteAccountPopup ref="popupCancel" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import DeleteAccountPopup from '@/app/components/billing/DeleteAccountPopup.vue'

const popupCancel = ref<InstanceType<typeof DeleteAccountPopup> | null>(null)

function showPopup(): void {
  if (!popupCancel.value) {
    return
  }

  popupCancel.value.show()
}
</script>

<style lang="scss" scoped>
p {
  max-width: 600px;
}

.night-mode {
  .delete-account__btn {
    background-color: $c-red-3;
    @include hover {
      background-color: $c-red-4;
    }
  }
}

.delete-account__header {
  margin-top: 24px;
}
</style>
